import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class UpdateUsersErrorAction implements Action {
  public static readonly type = 'UpdateUsersErrorAction';

  constructor(public error: BijbError) {
  }

  public type = UpdateUsersErrorAction.type;
}
